import type React from "react";

import styled from "@emotion/styled";
import { Spinner } from "@snapchat/snap-design-system";
import { PinIcon } from "@snapchat/snap-design-system-icons";

import { type GroupsGridItemModel } from "../../grid/model";

interface PinCellProps {
    group: GroupsGridItemModel;
    pinned: boolean;
    disabled?: boolean;
    isBeingPinned: boolean;
    onToggle: (group: GroupsGridItemModel, pinned: boolean) => void;
}

const Wrapper = styled.div<{ visible: boolean; disabled: boolean }>`
    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

    display: flex;
    align-items: center;
    justify-content: center;

    height: 100%;

    svg {
        visibility: ${({ visible }) => (visible ? "visible" : "hidden")};
    }

    :hover svg {
        visibility: visible;
    }
`;

export function PinCell({ group, disabled = false, pinned, isBeingPinned, onToggle }: PinCellProps) {
    const onClick = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        if (!disabled) {
            onToggle(group, !pinned);
        }
    };
    if (false) {
        return null;
    }
    if (isBeingPinned) {
        return (
            <div>
                <Spinner />
            </div>
        );
    }
    return (
        <Wrapper visible={pinned} disabled={disabled} onClick={onClick} title={pinned ? "Unpin" : "Pin"}>
            <PinIcon />
        </Wrapper>
    );
}
